<kendo-label
 [text]="'Definition of Metabolic Syndrome'"
 class="input-label-header"
></kendo-label>
<hr class="input-label-header-hr" />
<p>
 Must satisfy 
 <kendo-dropdownlist style="width: 75px; margin-left: 0.35rem; margin-right: 0.35rem;"
   [data]="numberOfSelectionsListItems"
   [(ngModel)]="numberOfSelectionsValue"
   [size]="'small'"
   (valueChange)="updateSelections()"
 ></kendo-dropdownlist> of the following:
</p>
<br />
<form [formGroup]="formGroup">
  <div class="form-check" *ngFor="let inputOption of singleInputOptions">
    <div class="row">
      <div class="col-4 mb-1">
        <kendo-label class="k-form" [text]="inputOption.customLabel" style="color: #92929f;"></kendo-label>
      </div>
      <div class="col-4 mb-1">
        <kendo-textbox
          [maxlength]="inputOption.maxlength"
          [minlength]="1"
          [formControlName]="inputOption.name"
          placeholder=""
          (valueChange)="updateSelections()"
          [clearButton]="true"
        >
        </kendo-textbox>
      </div>
    </div>
  </div>
  <br />
  <br />
  <div class="row">
    <div class="col-4"></div>
    <div class="col-4" style="text-align: center;">
      <kendo-label text="Male"></kendo-label>
    </div>
    <div class="col-4" style="text-align: center;">
      <kendo-label text="Female"></kendo-label>
    </div>
  </div>
  <div class="form-check" *ngFor="let inputOptionSet of limitInputOptions">
    <div class="row">
      <div class="col-4 mb-1">
        <kendo-label class="k-form" [text]="inputOptionSet[0].customLabel" style="color: #92929f;"></kendo-label>
      </div>
      <div class="col-4 mb-1" *ngFor="let inputOption of inputOptionSet">
        <kendo-textbox
          [maxlength]="inputOption.maxlength"
          [minlength]="1"
          [formControlName]="inputOption.name"
          placeholder=""
          (valueChange)="updateSelections()"
          [clearButton]="true"
        >
        </kendo-textbox>
      </div>
    </div>
  </div>
</form>
<br />
<button kendoButton (click)="setDefaults()">Set Default Values</button>
